module.exports = __webpack_public_path__ + "static/img/14000300.d28d3991.png";